class CartIcon extends HTMLElement {
    constructor() {
        super();
        this.countElement = this.querySelector('[data-cart-count]');
        this.onCartUpdate = this.onCartUpdate.bind(this);
    }

    connectedCallback() {
        document.addEventListener('cart:updated', this.onCartUpdate);
    }

    disconnectedCallback() {
        document.removeEventListener('cart:updated', this.onCartUpdate);
    }

    async onCartUpdate() {
        try {
            const response = await fetch('/cart.js');
            const cart = await response.json();
            
            if (this.countElement) {
                this.countElement.textContent = cart.item_count;
            }
        } catch (error) {
            console.error('Error fetching cart data for icon:', error);
        }
    }
}


customElements.define('cart-icon', CartIcon);